import React from 'react';
import cs from 'classnames';
import { connect } from 'react-redux';
import { push as pushPath } from 'react-router-redux';

import SizeWatcher from '~/components/SizeWatcher';
import LoadMap from '~/components/LoadMap';
import Backhaul from './Backhaul';
import BackhaulAlt from './BackhaulAlt';
import LoadingSpiner from '~/components/pages/MyAccount/share/LoadingSpiner';
import formatEquipment from '../formatEquipment';
import weightFormat from '~/misc/weight';
import BrokerInfo from './BrokerInfo';
import MapControls from './MapControls';
import mapDispatch from '~/misc/mapDispatch';
import { modalChange } from '~/modules/modal/actions';
import { getAverageRate, getSpecificIndicatorData, getCapacityRatioData } from '~/modules/loadsSearch/actions'

import { track } from '~/misc/metrics';
import Point from '~/components/common/DirectionPoint/index.js';
import TipPop from '~/components/common/TipPop';
import UnlockBtn from '~/components/common/UnlockEst'
import { rateCheckTips } from '~/misc/QAdocument.js';
import { formatPermillage } from '~/misc/strings.js';
import { dataQa, Desc, Header, Attr, formatDate, diffQueryLocation } from './helpers';
import config from '~/config';
import store from '~/store';
import accounting from '~/misc/accounting';
import css from './index.css';
import  get  from 'lodash/get';
import { getLocation, getSearchId } from "~/misc/actionLocation";
import { getDrivingTime } from '~/api/map'

import * as modes from '~/modules/modal/modes';
const jumpToRateCheck = (props, e) => {
  e.preventDefault();
  const item = props.item ? props.item : {};
  const query = props.query ? props.query : {};
  const obj = {
    equipment: item.equipment,
    from: item.from,
    to: item.to,
    dho: query.dho,
    distance: item.distance,
    target_price: item.target_price,
    pickup: Object.assign({}, item.original.pickup.location, item.original.pickup.address),
    drop_off: Object.assign({}, item.original.drop_off.location, item.original.drop_off.address),
  };
  const url = `${location.origin}/rate-check?param=${JSON.stringify(obj)}`;
  window.open(url);
  // const w = window.open('about:blank');
  // w.location.href = location.origin + url;
  // store.dispatch(pushPath(url));
};


const dataQaProp = (props, name) => dataQa(`${props['data-qa-name']}-${name}`);

const DateEntry = (props) => (
  props.date ? (
    <span className={dataQaProp(props, 'date')}>
      <span>{props.date.day}</span>
      {props.date.time ? (
        <span>
          <span> until </span>
          <span className={dataQaProp(props, 'time')}>{props.date.time}</span>
        </span>
      ) : null}
    </span>
  ) : null
);

const Location = (props) => (
  <span className={dataQaProp(props, 'location')}>
    <span className={css.locationCity}>
      {(props.address.city && `${props.address.city.toLowerCase()}, `)}
    </span>
    {/* {', '} */}
    <span>{props.address.state}</span>
  </span>
);
const CapacityLocation = ({cityInfo,score,isMember}) => {
  const {address} = cityInfo
  if(!address)return(<div></div>)
  const {state,city} = address
  let tag = ''

  if (score >= 0 && score < 20) {
    tag = <span className={css.capacityTag}>Dead cold</span>
  } else if (score >= 20 && score < 40) {
    tag = <span className={css.capacityTag}>Loose capacity</span>
  } else if (score >= 40 && score < 60) {
    tag = <span className={css.capacityTag}>Neutral market</span>
  } else if (score >= 60 && score < 80) {
    tag = <span className={css.capacityTag}>Tight capacity</span>
  } else if (score >= 80 && score <= 100) {
    tag = <span className={css.capacityTag}>Razor tight capacity</span>
  }

  return (
    <span className={css.tagContainer} >
      <span className={css.locationCity}>
        {city.toLowerCase()},
      </span>
      {/* {', '} */}
      <span>{state}</span>

      {

        tag
      }
    </span>
  )
}
const ShortLocation = ({ locationText,cityInfo }) => {
  if (cityInfo) {
    const { address } = cityInfo
    if (!address) return (<div></div>)
    const { state } = address
    return (<span>
      <span>{state}</span>
    </span>)
  } else {
    return (<span>
      <span>{locationText}</span>
    </span>)
  }
  
}
const UnlockLayer = ({ isMember, accountLevel, clickType, unlockFn }) => {

  if (isMember && accountLevel>=4) {
    return (<div></div>)
  } else {
    return (<div className={css.unlockLayer}>
      <UnlockBtn onClick={unlockFn.bind(this,clickType)} />
    </div>)
  }

};
const Deadhead = ({ data, qa, name }) => (data && (
  <Attr name={name}>
    <span className={dataQa(qa)}>{data.distance || '—'}</span> {data.distance ? 'mi' : null}
  </Attr>
));

const TripInfo = ({ isLoggedIn, item, query, goToRateCheck, showLogIn, isMember, showUpgradeToPremium, unlockFn,drivingTime }) => {
  const toDate = formatDate(item.to_date_local);
  const fromDate = formatDate(item.from_date_local);
  const originalFrom = diffQueryLocation(query, query.dho, 'from', item, 'from');
  const originalTo = diffQueryLocation(query, query.dhd, 'to', item, 'to');
  const { target_price, rate_price, average_rate_price, est_price } = item;
  const Rate = ({ priceString }) => (
    <span className={css.gridContext}>
      {(!!priceString || priceString === "0") ? priceString : "--"}
    </span>
  )
  const goToRateCheckBindTrack = (e) => {
    const eventName =
      window.location.href.indexOf("searchloads") >= 0
        ? "avg rate"
        : "avg_rate_inpage";
    track("rate check in load details", { eventName: 1 });
    return showUpgradeToPremium(eventName);
  };
  const RateBtn = () => (
    <span className={css.rateBtn} onClick={goToRateCheckBindTrack}>
      Rate Check
    </span>
  )
 
  return (
    <section className={css.group}>
      <div className={css.gridWrap}>
        <span className={css.gridTitle}>{target_price ?"Price" : ( est_price ? "EST. Price" : "Price")}</span> 
        <span className={css.gridTitle}>Rate/Mile</span>
        <span className={css.gridTitle}>Average Rate</span> 
        {
          target_price
            ? <Rate priceString={accounting.formatMoney(target_price)} />
            : est_price
              ? (isMember ? <Rate priceString={accounting.formatMoney(est_price)} /> : <UnlockBtn onClick={unlockFn} />)
              : (isMember ? '--' : <UnlockBtn onClick={unlockFn} />)
        }
        <Rate priceString={rate_price} />
        {isMember ? <Rate priceString={average_rate_price} /> : <RateBtn />}
      </div>
      <Header text='Trip' />
      <div className={css.gridWrap}>
        <span className={css.gridTitle}>Pickup Date</span>
        <span className={css.gridTitle}>Delivery Date</span>
        <span className={css.gridTitle}>Est Driving Time</span>
        <span className={css.gridContext}>{fromDate && fromDate.day || '--'}</span>
        <span className={css.gridContext}>{toDate && toDate.day || '--'}</span>
        <span className={css.gridContext}>{isMember ? drivingTime ? drivingTime : '--' : <UnlockBtn onClick={unlockFn}/> || '--'}</span>
      </div>
      <div className={css.location}>
        <Point
          isOrigin={true}
          title='Origin'
          text={'A'}
          className={css.locationIcon}
        />{' '}
        <Location {...item.original.pickup} data-qa-name='origin' />
        <span className={css.locationArrow}>→</span>
        <Point
          title='Destination'
          text={'B'}
          className={css.locationIcon}
        />{' '}
        <Location {...item.original.drop_off} data-qa-name='destination' />
      </div>
      <div className={css.gridWrap}>
        <span className={css.gridTitle}>Dh-O</span>
        <span className={css.gridTitle}>Distance</span>
        <span className={css.gridTitle}>Dh-D</span>
        <span className={css.gridContext}>{originalFrom && originalFrom.distance + ' mi' || '--'}</span>
        <span className={css.gridContext}>{item.distance ? item.distance + ' mi' : '--'}</span>
        <span className={css.gridContext}>{originalTo && originalTo.distance + ' mi' || '--'}</span>
      </div>
    </section>
  );
};


const LoadInfo = ({ description, comments, equipment_detailed: eqs, weight, length, showFuel,  distance, isMember, showUpgradeToPremium}) => (
  <section className={css.group}>
    <Header text='Load' />
    <div className={css.gridWrap}>
      <span className={css.gridTitle}>Weight</span>
      <span className={css.gridTitle}>Length</span>
      <span className={css.gridTitle}>Fuel Surcharge</span>
      <span className={css.gridContext}>{weightFormat(weight)}</span>
      <span className={css.gridContext}>{length ? `${length}ft` : '—'}</span>
      <span className={css.gridContext}>
        {
          isMember 
          ? <a className={cs(css.link)}  onClick={()=>showFuel(distance)}>{accounting.formatMoney((3 - 2.8) / 5.5 * distance, "$", 2)}</a>
          : <UnlockBtn 
            onClick = {()=> showUpgradeToPremium("fuel surcharge")}
          />
        }
      </span>
    </div>
    <div className={css.gridWrap}>
      <span className={cs(css.gridTitle, css.overlayout)}>Equipment and Accessories</span>
      <span className={cs(css.gridContext, css.overlayout)}> {eqs ? formatEquipment(eqs) : '—'}</span>
    </div>
    <div className={css.gridWrap}>
      <span className={cs(css.gridTitle, css.overlayout)}>Description and Comments</span>
      <span className={cs(css.gridContext, css.overlayout)}>{
        (description || comments) ? (
          <div className={dataQa('description')}>
            {description && <span className={cs(css.textPart, dataQa('desc-value'))}>{description}</span>}
            {comments && <span className={cs(css.textPart, dataQa('desc-value'))}>{comments}</span>}
          </div>
        ) : '—'
      }</span>
    </div>
  </section>
);

const LoadCardRender = ({
  isLoggedIn, item, query, isPremium, deleted, deletedByBroker, showLink, trackLoadLink, accountLevel, hideBroker,
  collectionTheCompany, noCollectionCompany, saveClick, hideClick, goToRateCheck, showLogIn, isMember,
  showUpgradeToPremium, unlockFn, unlockUltimateFn, myloadsType, indicatorData, capacityRatioData, showFuel, autoAction
},{drivingTime}) => {
  return (
    <div className={cs(css.loadCard, 'qa-load-details', deleted && css.removedLoadCard)}>
      {(deleted && !myloadsType) && (<div className={cs(css.removedLoadMessage, 'qa-removedLoadMessage')}>
        This post has been removed
      </div>)}

      {(deletedByBroker && !myloadsType) && (<div className={cs(css.removedLoadMessage, 'qa-removedLoadMessage')}>
        This post has been deleted by broker
      </div>)}
      {
        ((deleted || deletedByBroker) && !myloadsType) && (<div className={css.removedLoadMask}></div>)
      }
      <div className={css.mainInfo}>
        <TripInfo
          isLoggedIn={isLoggedIn}
          item={item} query={query}
          drivingTime={drivingTime}
          goToRateCheck={goToRateCheck}
          showLogIn={showLogIn}
          isMember={isMember}
          showUpgradeToPremium={showUpgradeToPremium}
          unlockFn={unlockFn}
        />
        <LoadInfo 
          {...item} 
          deleted={deleted} 
          showFuel={showFuel} 
          isMember={isMember} 
          showUpgradeToPremium={showUpgradeToPremium}
        />
        <BrokerInfo
          {...item}
          isPremium={isPremium}
          accountLevel={accountLevel}
          deleted={deleted}
          hideBroker={hideBroker}
          collectionTheCompany={collectionTheCompany}
          noCollectionCompany={noCollectionCompany}
          saveClick={saveClick}
          hideClick={hideClick}
          source={item.source}
          loadIdentity={item.identity}
          myloadsType={myloadsType}
          autoAction={autoAction}
        />
        {showLink && <div className={cs(css.group, css.shareLink)}>
          <div className={css.iconPin}></div>
          share &nbsp;<a
            href={
              `/loads/${item.id}/from-${item.from_city || item.from_state || 'Anywhere'}-to-${item.to_city || item.to_state || 'Anywhere'}`
            }
            target='_blank'
            onClick={trackLoadLink}
            className={cs(css.link, css.shareLinksText,)}
          >link to this load</a>
        </div>}
      </div>
      <div className={cs(css.additionalInfo, css.twoRows)}>
        <div className={css.mapContainer}>
          <SizeWatcher className={css.mapWrap}>
            <LoadMap loadId={item.id} />
          </SizeWatcher>
          <div className={css.mapButton}>
            <MapControls id={item.id} identity={item.identity} dataQa={dataQa} />
          </div>
        </div>
        <div className={css.backhaulWrap}>
          {config.backhaulDates
            ? <BackhaulAlt loadIdentity={item.identity} />
            : <Backhaul loadIdentity={item.identity} />}
          <div className={css.capacityWrapper}>

            <div className={css.capacityWrapper}>
              <Header text="Capacity Ratio" />
              <div className={css.capacityInnerWrapper}>
                <UnlockLayer isMember={isMember} accountLevel={accountLevel} clickType={'ratio'} unlockFn={unlockUltimateFn} />

                {
                  capacityRatioData && capacityRatioData.length ? (capacityRatioData.map((item, index) => (
                    <section className={css.group} key={index}>
                      <div className={css.gridContainer}>

                        <div className={css.gridCityName}>
                        <ShortLocation locationText={item.state}  data-qa-name='origin' />
                        </div>
                        <div className={css.gridWrap}>
                          <span className={css.gridTitle}>Inbound</span>
                          <span className={css.gridTitle}>Intrastate</span>
                          <span className={css.gridTitle}>Outbound</span>
                          <span className={css.gridContext}>{isMember && accountLevel>=4 ? item.in >= 0 ? formatPermillage(item.in) : '--' : '--'}</span>
                          <span className={css.gridContext}>{isMember && accountLevel>=4 ? item.intrastate >= 0 ? formatPermillage(item.intrastate) : '--' : '--'}</span>
                          <span className={css.gridContext}>{isMember && accountLevel>=4 ? item.out >= 0 ? formatPermillage(item.out) : '--' : '--'}</span>
                        </div>
                      </div>
                    </section>)
                  )) : (<section className={css.group}>
                    <div className={css.gridContainer}>

                      <div className={css.gridCityName}>
                        <ShortLocation cityInfo={item && item.original && item.original.pickup || {}}  data-qa-name='origin' />
                      </div>
                      <div className={css.gridWrap}>
                        <span className={css.gridTitle}>Inbound</span>
                        <span className={css.gridTitle}>Intrastate</span>
                        <span className={css.gridTitle}>Outbound</span>
                        <span className={css.gridContext}>{isMember && accountLevel>=4 ? '--' : '**9'}</span>
                        <span className={css.gridContext}>{isMember && accountLevel>=4 ? '--' : '**9'}</span>
                        <span className={css.gridContext}>{isMember && accountLevel>=4 ? '--' : '**9'}</span>
                      </div>
                    </div>
                    <div className={css.gridContainer}>

                      <div className={css.gridCityName}>
                        <ShortLocation cityInfo={item && item.original && item.original.drop_off || {}} data-qa-name='origin' />
                      </div>
                      <div className={css.gridWrap}>
                        <span className={css.gridTitle}>Inbound</span>
                        <span className={css.gridTitle}>Intrastate</span>
                        <span className={css.gridTitle}>Outbound</span>
                        <span className={css.gridContext}>{isMember && accountLevel>=4 ? '--' : '**9'}</span>
                        <span className={css.gridContext}>{isMember && accountLevel>=4 ? '--' : '**9'}</span>
                        <span className={css.gridContext}>{isMember && accountLevel>=4 ? '--' : '**9'}</span>
                      </div>
                    </div>
                  </section>)

                }


              </div>
            </div>
            <div className={css.capacityWrapper}>

              <Header text='Capacity Indicator' />
              <div className={css.capacityInnerWrapper}>
                {/* <Loading isLoading={indicatorDataLoading} /> */}
                <UnlockLayer isMember={isMember} accountLevel={accountLevel} clickType={'indicator'} unlockFn={unlockUltimateFn} />
                <div className={css.indicatorGroup}>
                  <div className={css.indicatorTitle}>
                    <CapacityLocation cityInfo={item && item.original && item.original.pickup} isMember={isMember} score={ indicatorData.pickUpScore} data-qa-name='origin' />
                    {isMember && accountLevel>=4 ? indicatorData.pickUpScore > -1 ? indicatorData.pickUpScore : <span className={css.noData}>No Data</span> : '*9'}
                  </div>
                  <div className={css.indicator}>
                    <div className={css.progressOutterWrap}>
                      <div className={css.nowProgress} style={{ left: `${isMember && accountLevel>=4 ? indicatorData.pickUpScore >= 0 ? indicatorData.pickUpScore : 0 : 0}%` }}></div>
                    </div>
                  </div>
                  <div className={css.indicatorIntro}>
                    <div className={css.introText}>Loose Market</div>
                    <div className={css.introText}>Tight Market</div>
                  </div>
                </div>
                <div className={css.indicatorGroup}>
                  <div className={css.indicatorTitle}>
                  <CapacityLocation cityInfo={item && item.original && item.original.drop_off} isMember={isMember} score={ indicatorData.pickUpScore} data-qa-name='origin' />
                   
                    {isMember&& accountLevel>=4 ? indicatorData.dropOffScore > -1 ? indicatorData.dropOffScore :  <span className={css.noData}>No Data</span> : '*9'}
                  </div>
                  <div className={css.indicator}>
                    <div className={css.progressOutterWrap}>
                      <div className={css.nowProgress} style={{ left: `${isMember && accountLevel>=4 ? indicatorData.dropOffScore >= 0 ? indicatorData.dropOffScore  : 0 : 0}%` }}></div>
                    </div>
                  </div>
                  <div className={css.indicatorIntro}>
                    <div className={css.introText}>Loose Market</div>
                    <div className={css.introText}>Tight Market</div>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>

      </div>
    </div>
  )
};


class LoadCard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      drivingTime:''
    }
  }
  componentDidMount() {
    const { item,accountLevel,isMember } = this.props;
    const { equipment, from_state, to_state, id, from, to, to_location, from_location } = item;
    const pickUp = Object.assign({
      address: from,
    }, from_location)
    const dropOff = Object.assign({
      address: to,
    }, to_location)
    this.props.getAverageRate({
      equipment: equipment[0],
      from: from_state,
      to: [to_state],
      id
    })

   
    // Show extra information in load details page if user is memerber
    if(isMember){ 
      // show driving time in load details page
      getDrivingTime({
        origin:{...from_location},
        destination:{...to_location}
      }).then((res) => {
        this.setState({
          drivingTime:res
        })
      })
    }
    // account level higher than premium fetch indicator and capacity ratio data
    if(accountLevel >= 4){


      this.props.getSpecificIndicatorData({
        equipment: equipment[0],
        pickUp,
        dropOff
      })
      this.props.getCapacityRatioData({
        equipment: equipment[0],
        from: from_state,
        to: to_state
      })
    }
  }
  render = () => LoadCardRender(this.props,this.state);
}

export default connect(({ user, account, loadsSearch }) => ({
  isLoggedIn: user.isLoggedIn,
  indicatorData: loadsSearch.indicatorData,
  capacityRatioData: loadsSearch.capacityRatioData,
  accountLevel:account.accountLevel,
  searchId: get(loadsSearch, "results.searchId")
}), mapDispatch({
  trackLoadLink: (props) => {
    track('open_load_link', {
      loadId: props.item.id,
    });
    track("Load Actions", {
      Action: "Share Load Link",
      loadId: props.item.id,
      searchId: getSearchId(),
      Placement: getLocation(),
    })
  },
  showLogIn: () => modalChange('login', 'rate-check'),
  goToRateCheck: jumpToRateCheck,
  hideBroker: (props, data) => props.hideBroker(data),
  collectionTheCompany: (props, data) => props.collectionTheCompany(data),
  noCollectionCompany: (props, data) => props.noCollectionCompany(data),
  showUpgradeToPremium: (props, source) => modalChange('pop', {
    source: source,
    type: 'pop_upgrade_to_premium',
  }),
  showFuel: (props, distance) => modalChange(modes.FUEL_SURCHANGE,  {type: 'askPop', distance, _overflowDisable: true}),
  getAverageRate: (props, { equipment, from, to, id }) => getAverageRate({ equipment, from, to, id }),
  getSpecificIndicatorData: (props, { equipment, pickUp, dropOff }) => getSpecificIndicatorData({ equipment, pickUp, dropOff }),
  getCapacityRatioData: (props, { equipment, from, to }) => getCapacityRatioData({ equipment, from, to })
}))(LoadCard);



// WEBPACK FOOTER //
// ./src/components/search/results/LoadCard/index.js